import React, { useState, useEffect } from "react";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import TreeMultiSelect from "../../../../components/common/TreeSelect";

import {
  billsAllData,
  billsApprovedData,
  billsOnHoldData,
  billsPendingData,
  glAccounts,
  payers,
} from "../../../../data/accounting";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import { HiPaperClip } from "react-icons/hi";

import "./Invoices.css";
import { useNavigate } from "react-router-dom";

const PayablesInvoiceRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "Enter Bill",
      "1",
      "",
      "",
      "/accounting/payables_bills/bills/enter-bils"
    ),
    RightBarMethod("Automated AP", "2", "", "", ""),
    RightBarMethod(
      "Smart Bill Entry",
      "3",
      "",
      "",
      "/accounting/payables_bills/bills/smartbillentry"
    ),
    RightBarMethod(
      "Enter Utility Bill (RUBS)",
      "5",
      "",
      "",
      "/accounting/payables_bills/bills/utility-bill-details"
    ),
    RightBarMethod("Enter Credit", "6", "", "", ""),
    RightBarMethod(
      "Pay Bills",
      "7",
      "",
      "",
      "/accounting/payables_bills/paybills"
    ),
    RightBarMethod(
      "Tenant Payable",
      "8",
      "",
      "",
      "/accounting/payables_bills/bills/newtenantpayable"
    ),
    RightBarMethod(
      "New Recurring Bill",
      "9",
      "",
      "",
      "/accounting/payables_bills/recurring_invoices/newrecurringbill"
    ),
    RightBarMethod(
      "Manually Post Bills",
      "10",
      "",
      "",
      "/accounting/payables_bills/recurring_invoices/manually_post_bills"
    ),
    RightBarMethod(
      "Upload Bulk Bills",
      "11",
      "",
      "",
      "/accounting/payables_bills/bills/upload-bulk-bills"
    ),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Aged Payables Summary", "12", "", "", "/"),
      RightBarMethod("Bill Detail", "13", "", "", "/"),
      RightBarMethod("Vendor Ledger", "14", "", "", "/"),
    ]
  ),

  RightBarMethod(
    " HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("How to Refund Tenants", "15", "", "", "/")]
  ),
];

function Invoices() {
  const [value, setValue] = useState("all");
  const [tableData, setTableData] = useState([]);
  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  useEffect(() => {
    if (value === "all") {
      setTableData(billsAllData);
    } else if (value === "approved") {
      setTableData(billsApprovedData);
    } else if (value === "pending approval") {
      setTableData(billsPendingData);
    } else if (value === "on hold") {
      setTableData(billsOnHoldData);
    }
  }, [value]);

  const columns = [
    {
      title: "Payee",
      dataIndex: "payee",
      key: "payee",
      sorter: (a, b) => a.payee.length - b.payee.length,
      sortOrder: sortedInfo.columnKey === "payee" ? sortedInfo.order : null,
    },
    {
      title: "Ref. #",
      dataIndex: "reference",
      key: "reference",
      sorter: (a, b) => a.reference.length - b.reference.length,
      sortOrder: sortedInfo.columnKey === "reference" ? sortedInfo.order : null,
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      key: "billDate",
      sorter: (a, b) => a.billDate.length - b.billDate.length,
      sortOrder: sortedInfo.columnKey === "billDate" ? sortedInfo.order : null,
    },
    {
      title: "For",
      dataIndex: "for",
      key: "for",
      sorter: (a, b) => a.for.length - b.for.length,
      sortOrder: sortedInfo.columnKey === "for" ? sortedInfo.order : null,
    },
    {
      title: "Gl Account",
      dataIndex: "glAccount",
      key: "glAccount",
      sorter: (a, b) => a.glAccount.length - b.glAccount.length,
      sortOrder: sortedInfo.columnKey === "glAccount" ? sortedInfo.order : null,
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      sorter: (a, b) => a.dueDate.length - b.dueDate.length,
      sortOrder: sortedInfo.columnKey === "dueDate" ? sortedInfo.order : null,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <span className="onclick-text">{text}</span>,
      sorter: (a, b) => a.amount.length - b.amount.length,
      sortOrder: sortedInfo.columnKey === "amount" ? sortedInfo.order : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
    },
    {
      title: "Action",
      key: "action",
      render: () => <HiPaperClip />,
    },
  ];
  return (
    <>
      <div className="bills">
        <PageHeading heading="Bills" />
        <Row>
          <Col span={24}>
            <FilterContainer
              heading={"Filter payable invoices with the options below."}
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Units">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by units"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Select
                        options={[
                          { value: "Show Active Properties" },
                          { value: "Show All Properties" },
                          { value: "Show Hidden Properties" },
                        ]}
                        defaultValue="Show Active Properties"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payees">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by Payees"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="GL Accounts">
                      <TreeMultiSelect
                        options={[]}
                        placeholder="Select GL Account"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payment Type">
                      <Select
                        options={[
                          { value: "All" },
                          { value: "ACH Payments Only" },
                          { value: "Checks Only" },
                          { value: "Other Payments Only" },
                        ]}
                        defaultValue="All"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Bill Status All">
                      <Select
                        options={[
                          { value: "All" },
                          { value: "Paid" },
                          { value: "Unpaid" },
                        ]}
                        defaultValue="All"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Approval Status All">
                      <Select
                        options={[
                          { value: "All" },
                          { value: "Pending Approval" },
                          { value: "Approved" },
                        ]}
                        defaultValue="All"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Bill Date">
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Radio.Group
              value={value}
              onChange={(e) => setValue(e.target.value)}
            >
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value="pending approval">
                Pending Approval
              </Radio.Button>
              <Radio.Button value="on hold">On Hold</Radio.Button>
              <Radio.Button value="approved">Approved</Radio.Button>
            </Radio.Group>
          </Col>
          <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/payables_bills/bills/bills-item/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PayablesInvoiceRightBar} />
      </div>
    </>
  );
}

export default Invoices;
